// components/HeroSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import styles from "../Info.module.css";

const HeroSection = ({ onViewFeatures }) => {
  return (
    <header className={styles.hero}>
      <div className={styles.heroInner}>
        <div className={styles.heroContent}>
          <span className={styles.heroEyebrow}>
            <i className="fas fa-layer-group"></i>
            UmLang | اوملنگ
          </span>
          <h1 className={styles.heroTitle}>
            زبان رو از دل{" "}
            <span className={styles.heroTitleAccent}>فیلم و سریال</span> یاد
            بگیر
          </h1>
          <p className={styles.heroSubtitle}>
            یادگیری زبان با فیلم و سریال، روشی نوین و لذت‌بخش. زیرنویس دوگانه،
            ترجمه لحظه‌ای لغات و مرور هوشمند — همه‌ش توی یک پلیر پیشرفته.
          </p>
          <div className={styles.heroActions}>
            <Link to="/Subscription" className={styles.ctaPrimary}>
              <i className="fas fa-play icon-start"></i>
              شروع یادگیری
            </Link>
            <button
              type="button"
              className={styles.ctaGhost}
              onClick={onViewFeatures}
            >
              <i className="fas fa-list-check icon-start"></i>
              مشاهده ویژگی‌ها
            </button>
          </div>
        </div>

        <div className={styles.heroMockWrap}>
          <div className={styles.heroMock}>
            <div className={styles.mockScreen}>
              <div className={styles.mockGradient}></div>
              <div className={styles.mockCenterPlay}>
                <i className="fas fa-play"></i>
              </div>
              <div className={`${styles.mockCaption} ${styles.mockCaptionEn}`}>
                You've got more in common with the clown.
              </div>
              <div className={`${styles.mockCaption} ${styles.mockCaptionFa}`}>
                تو بیشتر با دلقک اشتراک داری.
              </div>
              <div className={styles.mockWordChip}>
                <span>common</span>
                <i className="fas fa-chevron-up"></i>
                <div className={styles.mockWordTooltip}>مشترک، وجه اشتراک</div>
              </div>
            </div>
            <div className={styles.mockControls}>
              <div className={styles.mockProgress}>
                <div className={styles.mockProgressFill}></div>
              </div>
              <div className={styles.mockIcons}>
                <i className="fas fa-play"></i>
                <i className="fas fa-volume-up"></i>
                <i className="fas fa-closed-captioning"></i>
                <i className="fas fa-expand"></i>
              </div>
            </div>
          </div>
          <div className={styles.heroGlow}></div>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;